import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
const HelpIcon = (props) => {
  return (
    <HelpOutlineIcon
      style={{
        color: "#6fc0ff",
        width: 24,
        height: 24,
      }}
    />
  );
};

export default HelpIcon;
